import 'css-chunksrc/client/pages/searchPage/loader/styles.scss';export default {
  "loader": "_loader_1mwfx_1",
  "section": "_section_1mwfx_5",
  "title": "_title_1mwfx_9",
  "list": "_list_1mwfx_17"
};